import { FC, ReactNode, useState } from "react";

import { GlobalErrorLayout } from "src/errors/GlobalErrorLayout.tsx";
import Page500 from "src/errors/Page500.tsx";
import Page502 from "src/errors/Page502.tsx";
import { useErrorListener, useReloadListener } from "src/hooks/useEvents.ts";

export const ErrorHandlingProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [error, setError] = useState<ReactNode | undefined>(undefined);
  useErrorListener((message) => {
    if (message.code === "500") {
      setError(<Page500 />);
    }
    if (message.code === "502") {
      setError(<Page502 />);
    }
  });

  useReloadListener(() => {
    setError(undefined);
  });

  return error ? <GlobalErrorLayout>{error}</GlobalErrorLayout> : children;
};
